import { CusipStr, IsinStr } from '@moment/domain-types'
import { IdentifierType } from '@moment/trading-types/reference-data'

export function isValidISIN(str: string): boolean {
  return IsinStr.safeParse(str).success
}

export function isValidCUSIP(str: string): boolean {
  return CusipStr.safeParse(str).success
}

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function isValidInstrumentIdFormat(str: string) {
  return isValidISIN(str) || isValidCUSIP(str)
}

export function getInstrumentType(str: string): IdentifierType | undefined {
  if (isValidISIN(str)) {
    return IdentifierType.ISIN
  }
  if (isValidCUSIP(str)) {
    return IdentifierType.CUSIP
  }
  return undefined
}
